'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var styled = require('styled-components');
var interweave = require('interweave');
var StyledThemeProvider = require('../../providers/StyledThemeProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const MarkupWrapper = styled__default["default"].span.withConfig({
  componentId: "sc-1j7ukbx-0"
})(_ref => {
  let {
    theme
  } = _ref;
  return {
    '& a': theme.linksNoneDefault,
    '& a:hover, & a:focus, & a:active': theme.linksNoneHover
  };
});
const StyledMarkup = _ref2 => {
  let {
    content,
    style,
    noWrap,
    ...props
  } = _ref2;
  if ( /*#__PURE__*/React__default["default"].isValidElement(content)) return content;
  if (typeof content !== 'string') return null;
  if (props.tagName) return /*#__PURE__*/React__default["default"].createElement(interweave.Markup, _extends__default["default"]({
    content: content
  }, props));
  if (noWrap) return /*#__PURE__*/React__default["default"].createElement(interweave.Markup, _extends__default["default"]({
    content: content
  }, props, {
    noWrap: true
  }));
  return /*#__PURE__*/React__default["default"].createElement(MarkupWrapper, {
    style: style
  }, /*#__PURE__*/React__default["default"].createElement(interweave.Markup, _extends__default["default"]({
    content: content
  }, props, {
    noWrap: true
  })));
};
var StyledMarkup$1 = StyledThemeProvider.withStyledThemeProvider(StyledMarkup, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
});

exports["default"] = StyledMarkup$1;
